import $ from 'jquery';
import _ from 'lodash';

const createModalHtml = tpl => `<div class="modal-overlay">${tpl}</div>`;

class Modal {
	constructor({ template, events, ...other }) {
		if (!template) {
			throw new Error("Instance of Modal class should contain template");
		}

		this.id = _.uniqueId('modal_');

		this.options = {
			template,
			events,
			...other
		};

		this.render().bindUI();
	}

	render() {
		const html = createModalHtml(this.options.template);

		this.$html = $(html);

		$(document.body).append(this.$html);

		return this;
	}

	bindUI() {
		_.each(this.options.events, (callback, key) => {
			const
				[event_name, selector] = key.split(' '),
				func = _.isFunction(callback) ? callback : this[callback];

			if (!_.isFunction(func)) {
				throw new Error(`${callback} is not a field of the modal`);
			}

			this.$html.find(selector).on(event_name, func.bind(this));
		});

		return this;
	}

	unBindUI(){
		this.$html.off();

		return this;
	}

	close() {
		this.unBindUI()
			.$html.remove();

		return this;
	}
}

export default class ModalFactory {
	constructor() {
		throw new Error("ModalFactory class can't be an instance");
	}

	static create(args) {
		return new Modal(args);
	}
}